const React = require('react');
const { default: styled } = require('@emotion/styled');
const { useLoaderData, useNavigate } = require('react-router-dom');

const FullPageWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-center: center;
  align-items: center;
`
const ErrorContainer = styled("div")`
    max-width: 600px;
    text-align: center;
    width: 100%;
`

const ErrorCode = styled("div")`
    font-size: 6rem;
  font-weight: 300;
  color: #333;
  margin-bottom: 16px;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 4rem;
  }
`

const ErrorTitle = styled("h1")`
  font-size: 1.5rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const ErrorDescription = styled("div")`
  color: #666;
  font-size: 1rem;
  margin-bottom: 32px;
  line-height: 1.6;
`;

const ErrorActions = styled("div")`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;

    button {
      width: 200px;
    }
  }
`;

const Button = styled("button")`
  display: inline-block;
  padding: 12px 24px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-decoration: none;
  color: #333;
  background: white;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }

  &.primary {
    background: #0066cc;
    color: white;
    border-color: #0066cc;

    &:hover {
      background: #0052a3;
      border-color: #0052a3;
    }
  }
`;

const ErrorDetails = styled("div")`
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
  font-size: 0.85rem;
  color: #999;
`;

const NotFoundPage = () => {
    const data = useLoaderData() || {};
    const {
        statusCode = 404,
        title = 'Page Not Found',
        hostname,
        timestamp,
        errorCode
    } = data;
    const navigate = useNavigate();

    return (
        <FullPageWrapper>
            <ErrorContainer>
                <ErrorCode>{statusCode}</ErrorCode>

                {statusCode === 404 && <ErrorTitle>{title}</ErrorTitle>}

                <ErrorDescription>
                    {
                        statusCode === 404
                            ? "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
                            : title
                    }
                </ErrorDescription>

                <ErrorActions>
                    {/* <Button className="primary" onClick={() => history.back()}>
                        Go Back
                    </Button> */}
                    <Button className="primary" onClick={() => navigate(-1)}>
                        Go Back
                    </Button>
                    
                </ErrorActions>

                <ErrorDetails>
                    {hostname && <div>Request to: {hostname}</div>}
                    {timestamp && <div>Time: {new Date(timestamp).toISOString()}</div>}
                    {errorCode && <div>Error Code: {errorCode}</div>}
                </ErrorDetails>
            </ErrorContainer>
        </FullPageWrapper>
    )
}

module.exports = NotFoundPage;
